/* eslint-disable max-depth */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { getCategoryDataForType } from '@selectors/data-types-selector';

const StyledFormControlLabel = withStyles({
  root: {
    marginLeft: 0,
    marginRight: 0
  }
})(FormControlLabel);

const Toggle = ({
  data,
  dataCheckError,
  dataCheckErrorStyle,
  dataCheckValue,
  dataExtract,
  dataField,
  dataName,
  labelPosition,  // eslint-disable-line no-unused-vars -- not used in new API (default is label on right)
  style,
  styleName,
  disabled,
  label,
  labelStyle,
  toggled,
  onClick,
  name,
  ...other
}) => {
  const dataTypes = useSelector(state => state.dataTypes);

  // Calculate showError based on props and Redux state
  const showError = useMemo(() => {
    for (const fieldName of dataField) {
      const field = data[fieldName];
      // stop checking if anything error out
      if (field) {
        const dataType = dataName[fieldName];
        const categoryData = getCategoryDataForType({ dataTypes }, dataType);
        const selectedData = Object.values(categoryData).find(({ id }) => id === field);
        if (selectedData) {
          const value = selectedData[dataExtract];
          if (value === dataCheckValue) {
            return true;
          }
        }
      }
    }
    return false;
  }, [data, dataCheckValue, dataExtract, dataField, dataName, dataTypes]);

  return (
    <div style={style || {}} styleName={styleName || ''}>
      <StyledFormControlLabel
        control={
          <Switch
            checked={toggled || false}
            onClick={onClick}
            disabled={disabled || showError}
            name={name}
            color="primary"
            {...other}
          />
        }
        label={<span style={labelStyle}>{label}</span>}
        disabled={disabled || showError}
      />
      {showError && <div style={dataCheckErrorStyle || {}}>{dataCheckError}</div>}
    </div>
  );
};

Toggle.propTypes = {
  data: PropTypes.object,
  dataCheckError: PropTypes.string,
  dataCheckErrorStyle: PropTypes.object,
  dataCheckValue: PropTypes.any,  // eslint-disable-line react/forbid-prop-types
  dataExtract: PropTypes.string,
  dataField: PropTypes.array,
  dataName: PropTypes.object,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  labelPosition: PropTypes.string,
  labelStyle: PropTypes.object,
  name: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  styleName: PropTypes.string,
  toggled: PropTypes.bool
};

export default Toggle;
